














import { Component, Vue, Prop } from 'vue-property-decorator';
import { CourseFormSelect, TemplateSelect } from '@/components/form';

import { Record, Plan } from '@/domains/work';
import { Template } from '@/domains/template';
import { Load } from '@/domains/system';
import { saveRecordApi } from '@/api/work/RecordApi';

@Component({
  name: 'RecordCreateDialog',
  components: {
    CourseFormSelect,
    TemplateSelect,
  },
})
export default class RecordCreateDialog extends Vue {
  /** bus */
  @Prop()
  private bus: Vue;

  /** 会话显示 */
  private visible: boolean = false;

  /** 记录 */
  private form: Record = null;

  private save() {
    Load.startFullLoad('正在创建档案，请稍等。');
    saveRecordApi(this.form).then((result: any) => {
      Load.stopFullLoad();
      this.bus.$emit('record-template-dialog', Record.build(result));
      this.visible = false;
    }).catch(() => {
      Load.stopFullLoad();
    });
  }

  private createHandler() {
    this.bus.$on('record-create-dialog', (data: Plan) => {
      const record: Record = new Record();
      const plan: Plan = new Plan();
      const template: Template = new Template();
      record.plan = plan;
      record.template = template;
      record.courseFormId = 1;
      plan.id = data.id;
      template.id = 5;
      this.form = record;
      this.visible = true;
    });
  }

  private mounted() {
    this.createHandler();
  }
}
